/**
 * Web Component: OK 按钮
 */
// const say = (...a) => console.log('[WebPush]', ...a);

class WebPushOkButton extends HTMLElement {
  /* data 属性名 → 状态名 的映射表（唯一配置源） */
  static get TEXT_DATA_MAP () {
    return {
      idle: 'textIdle', // data-text-idle
      loading: 'textLoading', // data-text-loading
      subscribed: 'textSubscribed' // data-text-subscribed
    }
  }

  static get observedAttributes () {
    return ['state']
  }

  constructor () {
    super()
    // 状态: idle | loading | subscribed
    this._state = 'idle'
    this._texts = {
      idle: 'Subscribe',
      loading: 'Loading...',
      subscribed: 'Subscribed'
    }
  }

  connectedCallback () {
    this.readTexts()
    this.render()
    this.addEventListener('click', this.handleClick.bind(this))
  }

  readTexts () {
    const d = this.dataset
    Object.entries(WebPushOkButton.TEXT_DATA_MAP).forEach(
      ([state, dataKey]) => {
        const val = d[dataKey]
        if (typeof val === 'string' && val.trim() !== '') {
          this._texts[state] = val.trim()
        }
      }
    )
    say('OK button texts:', this._texts)
  }

  attributeChangedCallback (name, oldValue, newValue) {
    if (name === 'state') {
      this._state = newValue || 'idle'
      this.render()
    }
  }

  get state () {
    return this._state
  }
  set state (val) {
    this._state = val
    this.setAttribute('state', val)
  }

  render () {
    const { text, icon, classes, disabled } = this.getStateConfig()

    const baseClasses =
      'tw:px-5 tw:py-2 tw:text-sm tw:font-medium tw:rounded-full tw:transition-all tw:duration-200 tw:flex tw:items-center tw:gap-2 tw:whitespace-nowrap'

    this.className = `${baseClasses} ${classes}`
    this.innerHTML = `${icon}<span>${text}</span>`

    /* disabled：语义属性 + aria + 鼠标/键盘均不可点（handleClick 里还会拦一道） */
    this.toggleAttribute('disabled', disabled)
    this.setAttribute('aria-disabled', disabled ? 'true' : 'false')
    this.style.pointerEvents = disabled ? 'none' : 'auto'
  }

  getStateConfig () {
    const t = this._texts

    const configs = {
      idle: {
        text: t.idle,
        icon: '',
        classes:
          'tw:bg-black tw:text-white hover:tw:bg-gray-800 tw:cursor-pointer',
        disabled: false
      },
      loading: {
        text: t.loading,
        icon: `<svg class="tw:animate-spin tw:h-4 tw:w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="tw:opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="tw:opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>`,
        classes: 'tw:bg-gray-400 tw:text-white tw:cursor-not-allowed',
        disabled: true
      },
      subscribed: {
        text: t.subscribed,
        icon: `<svg class="tw:h-4 tw:w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
          </svg>`,
        classes: 'tw:bg-green-500 tw:text-white tw:cursor-default',
        disabled: true
      }
    }

    return configs[this._state] || configs.idle
  }

  handleClick (e) {
    if (this._state !== 'idle') {
      e.preventDefault()
      e.stopPropagation()
      return
    }
    this.dispatchEvent(
      new CustomEvent('webpush-subscribe', {
        bubbles: true
      })
    )
  }
}

customElements.define('webpush-ok-button', WebPushOkButton)
